import { Reducer, Action } from "redux";
import { IBreachesAndScamsState, KnownAction, RECEIVE_BREACHES_AND_SCAMS_DATA, SHOW_LOADER } from "./types";

export const reducer: Reducer<IBreachesAndScamsState> = (state: IBreachesAndScamsState | undefined, incomingAction: Action): IBreachesAndScamsState => {
    if (state === undefined) {
        return { breachesAndScamsData: [], isLoading: false };
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case RECEIVE_BREACHES_AND_SCAMS_DATA:
            return {
                ...state,
                breachesAndScamsData: action.breachesAndScamsData,
            };
        case SHOW_LOADER:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        default:
            return state;
    }
};
